module.exports = __webpack_public_path__ + "img/upucivanje-radnika.e50ea9e3.png";